import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "@/utils/axios"

export interface Project {
  id: string
  name: string
  slug: string
  created_at: string
  updated_at: string
}

export function useProjects() {
  return useQuery({
    queryKey: ["projects"],
    queryFn: async () => {
      const res = await axios.get<{ projects: Project[] }>("/v1.0/projects")
      return res.data.projects
    },
    staleTime: 60_000,
  })
}

export function useCreateProject() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (name: string) => {
      const res = await axios.post<{ project: Project }>("/v1.0/projects", { name })
      return res.data.project
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["projects"] }),
  })
}

export function useRenameProject() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, name }: { id: string; name: string }) => {
      const res = await axios.patch<{ project: Project }>(`/v1.0/projects/${id}`, { name })
      return res.data.project
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["projects"] }),
  })
}

export function useDeleteProject() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      await axios.delete(`/v1.0/projects/${id}`)
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["projects"] }),
  })
}
